import React, { useRef, useState, useEffect } from 'react'
import { useReactToPrint } from 'react-to-print'
import classes from './Modal.module.css'

const Modal = ({ children, onClose, invoiceNumber }) => {
    const printRef = useRef(null)
    const modalRef = useRef(null)

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: `Invoice ${invoiceNumber}`,
    })

    // Close modal when user clicks outside it
    const handleOverlayClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) onClose()
    }

    return (
        <div className={classes.overlay} onClick={handleOverlayClick}>
            <div className={classes.modal} ref={modalRef}>
                <button className={classes.closeBtn} onClick={onClose}>
                    ×
                </button>

                {/* ---------- PRINTABLE CONTENT ---------- */}
                <div className={classes.body}>
                    <div ref={printRef} className={classes.printArea}>
                        {children}
                    </div>

                    {/* ---------- ACTIONS (not printed) ---------- */}
                    <div className={classes.actions}>
                        <button onClick={handlePrint} className={classes.printBtn}>
                            Print
                        </button>
                    </div>
                </div>

                {/* ---------- MOBILE FLOATING PRINT BUTTON (ALWAYS VISIBLE) ---------- */}
                <button onClick={handlePrint} className={`${classes.floatingPrintBtn} ${classes.alwaysVisible}`}>
                    Print
                </button>
            </div>
        </div>
    )
}

export default Modal
